import React from 'react';
import { Provider } from 'react-redux';
import Layout from './src/components/Layout/Layout';
import store from './src/state/store';
import './src/styles/fonts.css';

export const wrapPageElement = ({ element, props }) => {
	return (
		<Provider store={store}>
			<Layout {...props}>{element}</Layout>
		</Provider>
	);
};
